const calcResult = state => {
  return state.calculator;
};

export default { calcResult };
